import { render, staticRenderFns } from "./WorkingAreaActiveCoverage.vue?vue&type=template&id=2b565f02&scoped=true"
import script from "./WorkingAreaActiveCoverage.vue?vue&type=script&lang=js"
export * from "./WorkingAreaActiveCoverage.vue?vue&type=script&lang=js"
import style0 from "./WorkingAreaActiveCoverage.vue?vue&type=style&index=0&id=2b565f02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b565f02",
  null
  
)

export default component.exports